import { Card } from "@mui/material";
import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const NotificationEmptyStateCard = styled(Card)<{
  isNotification?: boolean;
}>`
  height: ${(props) => (props.isNotification ? "100vh" : "65vh")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin: ${(props) => (props.isNotification ? "0px 16px" : "")};
  &.MuiPaper-root {
    border: 1px solid ${Colors.neutral_gray_300};
    border-radius: 8px;
    box-shadow: none;
  }
`;

export const NotificationEmptyStateText = styled.div<{
  color: string;
  fontFamilyBold?: boolean;
}>`
  font-family: ${(props) =>
    props.fontFamilyBold ? "Ringside Regular-Bold" : "Ringside Regular-Book"};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${(props) => props.color};
`;
